import { ButtonOutlineDangerStyle } from '../styles'
import RejectClaimModal from '../RejectClaimModal'
import { useSetRecoilState } from 'recoil'
import rejectClaimModalAtom from '@/recoil/rejectClaimModal'

function RejectClaimButton() {
  const setRejectClaimModal = useSetRecoilState(rejectClaimModalAtom)

  return (
    <div>
      <ButtonOutlineDangerStyle
        onClick={() => {
          setRejectClaimModal(true) // Open the modal using Recoil state
        }}
      >
        ปฏิเสธคำขอ
      </ButtonOutlineDangerStyle>
      <RejectClaimModal />
    </div>
  )
}

export default RejectClaimButton
